import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useState } from 'react';

const StyledButtonSwitcher = styled(Box)(({ theme }) => ({
  backgroundColor: '#DCDFF4',
  borderRadius: theme.spacing(4),
  position: 'relative',
}));
const StyledFirstButton = styled(Button)(({ theme }) => ({
  [`@media (max-width:${theme.breakpoints.values.sm}px)`]: {
    '&.MuiButton-defaultSecondary': {
      position: 'absolute',
      left: '-8px',
      backgroundColor: '#DCDFF4 !important',
      zIndex: 0,
    },
  },
}));
const StyledSecondButton = styled(Button)(({ theme }) => ({
  [`@media (max-width:${theme.breakpoints.values.sm}px)`]: {
    '&.MuiButton-defaultSecondary': {
      position: 'absolute',
      right: '-8px',
      backgroundColor: '#DCDFF4 !important',
      zIndex: 0,
    },
  },
}));

const ButtonSwitcher = ({ handleChangeFunc, values, selectedButtonIndex }) => {
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('lg'),
  );
  // const [selectedButtonIndex, setSelectedButtonIndex] = useState(0);

  const handleChangeButton = useCallback(
    e => {
      // setSelectedButtonIndex(prevState => (prevState === 0 ? 1 : 0));
      handleChangeFunc(e);
    },
    [handleChangeFunc],
  );

  return (
    <StyledButtonSwitcher
      sx={{
        marginLeft: isSmallScreen && selectedButtonIndex === 1 ? 2 : 'auto',
      }}
    >
      <StyledFirstButton
        onClick={handleChangeButton}
        data-type={0}
        variant='default'
        color={selectedButtonIndex === 0 ? 'primary' : 'secondary'}
        value={values.firstButton}
        disableRipple
      >
        <Typography
          variant={isSmallScreen ? 'h5' : 'h4'}
          sx={{
            fontWeight: 600,
          }}
        >
          {values.firstButtonText()}
        </Typography>
      </StyledFirstButton>
      {values.secondButtonText && (
        <StyledSecondButton
          onClick={handleChangeButton}
          data-type={1}
          variant='default'
          color={selectedButtonIndex === 1 ? 'primary' : 'secondary'}
          value={values.secondButton}
          disableRipple
        >
          <Typography
            variant={isSmallScreen ? 'h5' : 'h4'}
            sx={{
              fontWeight: 600,
            }}
          >
            {values.secondButtonText()}
          </Typography>
        </StyledSecondButton>
      )}
    </StyledButtonSwitcher>
  );
};

export default ButtonSwitcher;
